import cashSvg from "@/assets/cash.svg";
import trophySvg from "@/assets/funnel-trophy.svg";
import boltSVG from "@/assets/funnel-bolt.svg";
import { Button } from "@/components/ui/button";
import { ListItem } from "@/components/ListItem";
import { Logo } from "@/components/Logo";
import arrowLottie from "@/assets/lottie/arrow.lottie?url";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import { Tag } from "@/components/Tag/Tag";
import starsSVG from "@/assets/stars.svg";
import { MediaLogos } from "@/components/MediaLogos";
import { useIsLocationAllowed } from "@/hooks/useIsLocationAllowed";
import { SIGNED_IN_ROUTES } from "@skillscratch/shared-types";
import { SafePaddingContainer } from "@/components/SafePaddingContainer";
import type { CSSProperties } from "react";
import paymentlogos from "@/assets/paymentlogos.png"
import { useViewTransition } from "@/hooks/useViewTransition";
// import { useSwipeDetection } from "@/hooks/useSwipeDetection";
// import { useNavigate } from "react-router-dom";


// Type definitions
interface HeaderProps {
  locationName: string;
}

interface FooterProps {
  onContinue: () => void;
}

interface RatingTagProps {
  stateCode: string;
}

interface DottedLineProps {
  height?: string;
}

export function InfoPage() {
  // const { navigateToSignedInPage } = useSignedInNavigation();
  const { navigateNormal } = useViewTransition();
  const [isLocationAllowed] = useIsLocationAllowed();
  // const navigate = useNavigate();

  // const handleBack = () => {
  //   // @ts-expect-error It works
  //   navigate(-1, {
  //     viewTransition: true,
  //     state: { isBack: true },
  //   });
  // };

  // useSwipeDetection({
  //   minSwipeDistance: 50,
  //   onSwipeRight: () => {
  //     handleBack();
  //   }
  // });

  return (
    <div className="flex flex-col h-screen bg-white">
      <SafePaddingContainer orientation="header" className="flex flex-col h-full">
        {/* HEADER SECTION - top-aligned */}
        <Header locationName={isLocationAllowed?.locationName || "Error"} />
        
        {/* CONTENT SECTION - centered */}
        <div className="flex-grow flex pt-[20%] justify-center">
          <Content />
        </div>
      </SafePaddingContainer>
      <SafePaddingContainer orientation="footer" className="flex flex-col h-full">
        {/* FOOTER SECTION - bottom-aligned */}
        <Footer onContinue={() => navigateNormal(SIGNED_IN_ROUTES.PAGE1,
          {
            viewTransition: true,
            state: { isBack: false },
          }
        )} />
      </SafePaddingContainer>
    </div>
  );
}

// Header component with Logo and Rating Tag
function Header({ locationName }: HeaderProps) {
  return (
    <div className="flex flex-col items-center pt-6">
      <div className="mb-4">
        <Logo />
      </div>
      <RatingTag stateCode={locationName} />
    </div>
  );
};

// Content component with List Items
function Content() {
  return (
    <div className="w-full">
      {/* First item */}
      <div className="relative mb-12">
        <ListItem
          iconSrc={trophySvg}
          text="Play scratchers to win up to $4,600,000, real cash"
        />
        <DottedLine height="12vw" />
      </div>
      
      {/* Second item */}
      <div className="relative mb-12">
        <ListItem
          iconSrc={cashSvg}
          text='Enter jackpot drawings, win massive amounts'
        />
        <DottedLine height="12vw" />
      </div>
      
      {/* Third item */}
      <ListItem
        iconSrc={boltSVG}
        text={
        <div className="flex flex-col gap-2">
          24/7 safe payouts
          <img src={paymentlogos} className='w-full' alt='cashout methods' />
        </div>
        }
      />
    </div>
  );
};

// Footer component with Button and Media Logos
function Footer({ onContinue }: FooterProps) {
  return (
    <div className="mt-auto pb-6">
      <Button
        className="py-8 bg-blue text-white text-2xl font-bold w-full rounded-lg flex items-center justify-center gap-3 mb-2"
        shine
        onClick={onContinue}
      >
        <span className='items-center justify-center'>Awesome</span>
        <span className='h-5 w-5 flex items-center justify-center'>
            <DotLottieReact
                src={arrowLottie}
                autoplay
                loop
                style={{
                objectFit: "contain",
                }}
            />
        </span>
      </Button>
      
      <div className="mt-2">
        <MediaLogos />
      </div>
    </div>
  );
};

export function RatingTag({ stateCode }: RatingTagProps) {
  return (
    <Tag 
      backgroundColor="#00B67A" 
      textColor="#00B67A" 
      fontSize="1.0em" 
      opacity={0.1}
      paddingX="0.8em" 
      paddingY="0.4em"
    >
      <span className="font-bold tracking-wide mr-2">{`Official ${stateCode} App`}</span>
      {/* biome-ignore lint/a11y/useAltText: <explanation> */}
      <img src={starsSVG} className="h-6" />
    </Tag>
  );
};

export function DottedLine({ height = "20vw" }: DottedLineProps) {
  const dotLineStyle: CSSProperties = {
    position: "absolute",
    top: "100%",
    left: "1.5rem", 
    height,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center"
  };

  const dotStyle: CSSProperties = { 
    width: "4px", 
    height: "8px", 
    backgroundColor: "#E6F4F9" 
  };

  const middleDotStyle: CSSProperties = { 
    ...dotStyle, 
    margin: "8px 0" 
  };

  return (
    <div style={dotLineStyle}>
      <div style={dotStyle} />
      <div style={middleDotStyle} />
      <div style={dotStyle} />
    </div>
  );
};